module.exports = __webpack_public_path__ + "static/img/2017.204509d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2017.png
// module id = iCb2
// module chunks = 1